import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import { sendEvent } from "./global.js";

export function trackOutboundLink(url) {
	try {
		sendEvent("event", "Outbound", "Click", url, undefined, false);
		if (url == "https://consult.education.gov.uk/pshe/relationships-education-rse-health-education/consultation/") {
			fbq("track", "Purchase", { currency: "GBP", value: 1.0 });
		} else if (url == "https://www.eauk.org/sent") {
			fbq("track", "Purchase", { currency: "GBP", value: 1.0 });
		}
	} catch (err) {}
	return true;
}

if (!$("body").hasClass("devmode-true")) {
	$('a[href^="mailto:"]').click(function () {
		var emaillink = jQuery(this).attr("href");
		sendEvent("event", "Email Enquiry", "Mailto Click", emaillink, undefined, false);
		return true;
	});

	$('a[href^="tel:"]').click(function () {
		var telephonenumber = jQuery(this).attr("href");
		sendEvent("event", "Telephone Enquiry", "Tel Link Click", telephonenumber, undefined, false);
		return true;
	});

	// pdf function
	/*$('a[href$=".pdf"]').click(function(){
		var pdfurl=jQuery(this).attr('href');
		
		sendEvent('event', 'PDF Download', 'Download', pdfurl, undefined, false);
		fbq('track', 'Purchase', {currency: "GBP", value: 1.00, content_type: "PDF"});
		return true;
	});*/

	// attachment function
	/*$('.download-attachment a').click(function(){
		var dlurl=jQuery(this).attr('href');
		sendEvent('event', 'Attachment Download', 'Download', dlurl, undefined, false);
		fbq('track', 'Purchase', {currency: "GBP", value: 1.00, content_type: "Attachment"});
		return true;
	});*/

	//Job apply
	$(".apply, .apply-sidebar").click(function () {
		fbq("track", "Purchase", { currency: "GBP", value: 1.0 });
	});

	//Click profile drop down
	$(".profile-dropdown-btn").click(function () {
		if (!$(".profile-dropdown").hasClass("show")) {
			//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
			sendEvent("event", "Your account", "Interaction", "Open", undefined, false);
		}
	});

	//Track video plays
	$(".video-play, .video-img.enable-play").click(function () {
		var title = $(this).data("title");
		if (title) {
			//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
			sendEvent("event", "Video", "Play", title, undefined, false);
		}
	});

	//Track join us in header clicks
	$(".container .join-us").click(function () {
		//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
		sendEvent("event", "Join us header", "Interaction", window.location.href, undefined, false);
	});

	//Track social media sharing
	$(".sharing a").click(function () {
		if ($(this).hasClass("fb")) {
			//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
			sendEvent("event", "Social media share", "Facebook", window.location.href, undefined, false);
		} else if ($(this).hasClass("twitter")) {
			//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
			sendEvent("event", "Social media share", "Twitter", window.location.href, undefined, false);
		} else if ($(this).hasClass("messenger")) {
			//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
			sendEvent("event", "Social media share", "Messenger", window.location.href, undefined, false);
		} else if ($(this).hasClass("email")) {
			//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
			sendEvent("event", "Social media share", "Email", window.location.href, undefined, false);
		}
	});

	//Advertisement tracking
	$(document).on("click", ".sponsored,.sponsored-listing-idea-online", function () {
		link = $(this).attr("href");
		console.log(link);
		//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
		sendEvent("event", "Advertisement", "Click", link, undefined, false);
	});

	//Track if News and Views home ad is shown
	if ($(".sponsored-listing-idea-online").length) {
		var toldGoogle = false;
		var sponsored_home_link = $(".sponsored-listing-idea-online").attr("href");
		function isElementInView(element) {
			var elementBoundingBox = element.getBoundingClientRect();
			var elementTopY = elementBoundingBox.top;
			var elementBottomY = elementBoundingBox.top + elementBoundingBox.height;
			return elementTopY >= 0 && elementBottomY <= Math.min(document.documentElement.clientHeight, window.innerHeight || 0);
		}
		function checkElementViewability() {
			var elements = document.querySelectorAll(".sponsored-listing-idea-online");
			for (var i = 0; i < elements.length; i++) {
				const mediaQuery = window.matchMedia("(min-width: " + screen_sm + "px)");
				if (mediaQuery.matches && !toldGoogle) {
					if (isElementInView(elements[i])) {
						//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
						sendEvent("event", "Advertisement", "View", sponsored_home_link, undefined, false);

						toldGoogle = true;
						console.log("YES");
					}
				}
			}
		}
		checkElementViewability();
		$(window).on("scroll", checkElementViewability);
	}
}
